import moment from "moment";
import { BookingMonthBreakSide } from "@graphql";

/**
 * Whether the booking holds the given day of its week.
 *
 * A week that straddles a calendar month exists twice for customers that
 * invoice per month — one booking per month — and each side holds only the days
 * of its own month: the days from the Monday up to the break belong to the
 * first-month booking, the rest to its counterpart. The consultant app renders
 * a day from the side that owns it and from nowhere else, so hours entered on
 * the other side never reach the consultant.
 *
 * A booking that is not part of such a pair owns its whole week.
 */
export function ownsDay(
  weekMonday: Date | string | null | undefined,
  side: BookingMonthBreakSide | null | undefined,
  date: Date | string
): boolean {
  if (!side || !weekMonday) {
    return true;
  }

  // UTC throughout: the week is a Monday at 00:00 UTC, and reading it in a
  // negative-offset zone would resolve the previous month.
  const monday = moment.utc(weekMonday).startOf("isoWeek");
  const day = moment.utc(date);

  const isFirstMonth = day.year() === monday.year() && day.month() === monday.month();

  return side === BookingMonthBreakSide.FirstMonth ? isFirstMonth : !isFirstMonth;
}
